import { forwardRef, Ref, SVGAttributes } from 'react';
type Props = SVGAttributes<SVGSVGElement>;
const EditProfileIcon = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 20.25H4.5a.75.75 0 0 1-.75-.75v-4.2a.74.74 0 0 1 .22-.52L15.22 3.53a.75.75 0 0 1 1.06 0l4.19 4.19a.75.75 0 0 1 0 1.06L9 20.25ZM20.25 20.25H9M12.75 6 18 11.25" />
    </g>
  </svg>);
export default EditProfileIcon;